import React, { useState } from "react";
import { Card } from "../shared";
import { TeamChips } from "./TeamChips";
import { ActivityFeed } from "./ActivityFeed";

export const TeamSection = ({ dealKey, dealName }) => {
  const [tick, setTick] = useState(0);
  const bump = () => setTick((t) => t + 1);
  return (
    <>
      <Card title="Who's working on this" testid="team-section">
        <div className="tm-rows">
          <TeamChips scope="deal" dealKey={dealKey} dealName={dealName} label="Deal team" onChanged={bump} />
          <TeamChips scope="raise" dealKey={dealKey} dealName={dealName} label="Fundraising team" onChanged={bump} />
        </div>
        <div className="cm-empty" style={{ marginTop: 10 }}>Assign teammates to the deal or the raise; set an owner on each LP in the pipeline to split the chase list.</div>
      </Card>
      <ActivityFeed dealKey={dealKey} dealName={dealName} refreshKey={tick} />
    </>
  );
};
